import {
  IconButton,
  FormControl,
  OutlinedInput,
  InputAdornment,
  Box,
} from "@mui/material";
import IconConstants from "../../utils/IconConstants";

const SearchBar = ({
  height = "auto",
  startAdornment,
  endAdornment,
  borderRadius,
  setSearchKey,
  searchKey,
  handleSearch,
  placeholder,
  reportType,
  borderColor = "#F7A86E",
  setPage = () => {},
}) => {
  let dynamicPlaceholder = placeholder || "Search by name or number";

  if (reportType === "Occupancy Report") {
    dynamicPlaceholder = "Search by asset name or room number";
  } else if (reportType === "Charge Report") {
    dynamicPlaceholder = "Search by Guest Name";
  } else if (
    reportType === "Foreigner Report" ||
    reportType === "Cancellation Report"
  ) {
    dynamicPlaceholder = "Search by name or number";
  }

  return (
    <FormControl fullWidth>
      <OutlinedInput
        type={"text"}
        size="small"
        value={searchKey}
        placeholder={dynamicPlaceholder}
        startAdornment={
          startAdornment && (
            <InputAdornment
              position="start"
              onClick={() => {
                if (!!searchKey) {
                  handleSearch(searchKey);
                }
              }}
            >
              <IconButton sx={{ padding: 0 }} size="small">
                <Box
                  sx={{
                    mt: { xs: "4px", sm: 0 },
                    width: { sm: "1.919vw", md: "1.389vw" },
                    height: { sm: "1.919vw", md: "1.389vw" },
                  }}
                >
                  <img
                    src={IconConstants.SearchIcon}
                    alt=""
                    style={{ width: "100%", height: "100%" }}
                  />
                </Box>
              </IconButton>
            </InputAdornment>
          )
        }
        endAdornment={
          endAdornment && (
            <InputAdornment position="end">
              <IconButton
                sx={{ padding: 0 }}
                size="small"
                onClick={() => {
                  if (!!searchKey) {
                    setPage(0);
                    handleSearch(searchKey);
                  }
                }}
              >
                <Box
                  sx={{
                    height: { xs: "5vw", sm: "2vw", md: "1.4vw" },
                    width: { xs: "5vw", sm: "2vw", md: "1.4vw" },
                  }}
                >
                  <img
                    src={IconConstants.SearchIcon}
                    alt=""
                    style={{ width: "100%", height: "100%" }}
                  />
                </Box>
              </IconButton>
            </InputAdornment>
          )
        }
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: `${borderColor} !important`,
            borderWidth: "1px",
          },
          fontSize: { xs: "3.08vw", sm: "1.32vw", md: "0.833vw" },
          height: height,
          backgroundColor: "#FFFFFF",
          borderRadius: "30px",
        }}
        onChange={(event) => {
          setPage(0);
          setSearchKey(event?.target?.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !!searchKey) {
            setPage(0);
            handleSearch(searchKey);
          }
        }}
        onInput={(e) => {
          let { value } = e.target;
          // e.target.value = value.replace(/[^A-Za-z0-9\s]/g, "").replace(/^\s+/, "")
          e.target.value = value.replace(/^\s+/, "");
        }}
      />
    </FormControl>
  );
};

export default SearchBar;
